module.exports = __webpack_public_path__ + "static/img/智慧石梁河展示平台首页.c3d076c5.png";